webpackJsonp([142629428675168],{

/***/ 348:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"edges":[{"node":{"excerpt":"DMGT at a glance DMGT manages a balanced multinational portfolio of entrepreneurial companies,\nwith total revenues of around £xxx, that provide a diverse range of businesses\nand consumers with compelling information, analysis, insight, news and entertainment.","id":"/opt/build/repo/src/pages/blog/2017-01-04-just-in-small-batch-of-jamaican-blue-mountain-in-store-next-week.md absPath of file >>> MarkdownRemark","fields":{"slug":"/blog/2017-01-04-just-in-small-batch-of-jamaican-blue-mountain-in-store-next-week/"},"frontmatter":{"title":"Introduction","templateKey":"blog-post","date":"January 04, 2017"}}}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-5c04a3d6c462f63cc040.js